import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMenu,{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_c('country-flag',{attrs:{"country":"ge"}})],1)]}}])},[_c(VList,_vm._l((_vm.cultures),function(culture,index){return _c(VListItem,{key:index,on:{"click":function($event){return _vm.cultureSelection(culture.Name)}}},[_c(VListItemTitle,[_vm._v(_vm._s(culture.EnglishName)+" "+_vm._s(culture.NativeName))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }